/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_No_TournamentsInputs */



/**
* | output |
* | --- |
* | "No tournaments in this league yet." |
*
* @param {League_No_TournamentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_no_tournaments = /** @type {((inputs?: League_No_TournamentsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_No_TournamentsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun tournoi dans cette ligue pour l'instant.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay torneos en esta liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum torneio nesta liga ainda.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun torneo in questo campionato ancora.")
	return /** @type {LocalizedString} */ ("No tournaments in this league yet.")
});